// extracted by mini-css-extract-plugin
module.exports = {"notFound":"index-module--not-found--3X1B4","text":"index-module--text--312Hi","gotoTop":"index-module--goto-top--Wxp5r"};